export default __webpack_public_path__ + "static/media/screen7.318af93d.svg";